<template>
  <div class="bottom-qrcode-banner">
    <span class="bottom-qrcode-banner__title">{{ title }}</span>
    <img class="bottom-qrcode-banner__code" loading="lazy" :alt="title" :src="imgSrc" :title="title" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: `${process.env.SEEKER_WEB__S3_PREFIX}/img/${this.qrCodeFileName}`,
    }
  },
  props: {
    qrCodeFileName: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.bottom-qrcode-banner {
  @apply flex flex-row items-center;
  @apply p-1;
  @apply bg-grey-xlight;
  @apply z-10;
}
.bottom-qrcode-banner__title {
  @apply flex-1 min-w-0;
  @apply text-cbody1 font-cbody1 text-black;
  @apply text-left whitespace-pre-wrap;
  @apply mx-6;
}
.bottom-qrcode-banner__code {
  @apply mr-4;
  height: 54px;
  width: 54px;
}
</style>
